import Glider from 'glider-js/glider';

export default {
    init() {},
    finalize() {
        const businessCases = document.querySelector('.BusinessCases__Slider');
        if (businessCases) {
            new Glider(businessCases, {
                slidesToShow: 2,
                slidesToScroll: 2,
                draggable: true,
                arrows: {
                    prev: '.glider-prev',
                    next: '.glider-next',
                },
                responsive: [
                    {
                        breakpoint: 1023,
                        settings: {
                            slidesToShow: 4,
                            slidesToScroll: 1,
                        },
                    },
                    {
                        breakpoint: 676,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                        },
                    },
                ],
            });
        }
    },
};


// WEBPACK FOOTER //
// ./scripts/routes/archive-projects-data.js